import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { TranslateService } from '@ngx-translate/core';

const SweetAlert = require('sweetalert');

@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.scss']
})
export class RecoverComponent implements OnInit {

  valForm: FormGroup;

  constructor(
    public  settings: SettingsService,
    public  fb: FormBuilder,
    public  translateService: TranslateService
  ) {
    this.valForm = this.fb.group({
      'email': [null, Validators.compose([Validators.required, CustomValidators.email])]
    });
  }

  submitForm($ev, value: any) {
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {

      this.resetPassword(this.valForm.controls["email"].value, this.valForm)
    }
  }

  ngOnInit() {
  }


  resetPassword(email: string, valForm: FormGroup) {
    const component = this;
    Accounts.forgotPassword({ email: email }, function (err) {
      if (err) {
        if (err.message === 'User not found [403]') {
          component.showDialog('', component.translateService.instant('password_recover.EMAIL_SENT'), 'info'); // Nem kötjük az orrára, hogy nincs ilyen e-mail cím...
        } else {
          console.error("FORGOT PASSWORD ERROR"); console.error(err);
          component.showDialog('', component.translateService.instant('password_recover.EMAIL_SEND_PROBLEM'));
        }
      } else {
        component.showDialog('', component.translateService.instant('password_recover.EMAIL_SENT'), 'info');
        valForm.reset()
      }
    });
  }

  public  showDialog(title: string, text: string, type: string = "warning") {
    return SweetAlert({
      title: title,
      text: text,
      icon: type,
      buttons: {
        confirm: {
          text: "OK",
          value: true,
          visible: true,
          className: "btn-primary",
          closeModal: true
        }
      }
    });
  }

}
